type TLocation = {
	latitude: number;
	longitude: number;
	altitude: number;
};

export function distance2D(point1: TLocation, point2: TLocation) {
	const R = 6371; // Radius of the Earth in km
	const dLat = (point1.latitude - point2.latitude) * (Math.PI / 180);
	const dLon = (point1.longitude - point2.longitude) * (Math.PI / 180);
	const a =
		Math.sin(dLat / 2) * Math.sin(dLat / 2) +
		Math.cos(point1.latitude * (Math.PI / 180)) *
			Math.cos(point2.latitude * (Math.PI / 180)) *
			Math.sin(dLon / 2) *
			Math.sin(dLon / 2);
	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	return R * c; // Distance in km
}

export function distance3D(point1: TLocation, point2: TLocation) {
	const distance = distance2D(point1, point2);

	// Calculate the vertical separation (altitude)
	const altitudeDifference = Math.abs(point1.altitude - point2.altitude) / 1000;

	// Calculate the 3D distance using Pythagoras theorem
	const threeDDistance = Math.sqrt(
		Math.pow(distance, 2) + Math.pow(altitudeDifference, 2),
	);

	return threeDDistance;
}
